export const rush = [
  "ASAP (Today or Tomorrow)",
  "Next Week",
  "2 Weeks"
]
